export const FilterType = Object.freeze({
    ALL: Symbol("all"),
    ASSOCIATED: Symbol("associated"),
    UNASSOCIATED: Symbol("unassociated"),
    DEACTIVATED: Symbol("deactivated"),
    TESTING: Symbol("testing"),
    REQUIRES_ATTENTION: Symbol("requires_attention"),
});
